<template>
  <div class="weather">
    <!-- 气象标题 -->
    <div class="tab">
      <div class="tab-name">实时气象</div>
      <div class="tab-city">
        <div class="city-text">
          <img class="city-icon" src="../assets/position.png" />
          <div>当前城市</div>
        </div>
        <div class="city-name">{{ $store.getters["weather/getCityName"] }}</div>
      </div>
    </div>
    <!-- 加载样式 -->
    <Spin class="loading" v-if="loading">
      <div class="loading-container">
        <Icon class="demo-spin-icon-load" type="ios-loading" size="18" />
        <div class="loading-text">加载中...</div>
      </div>
    </Spin>
    <template v-else>
      <!-- 气象数据 -->
      <div class="empty" v-if="empty">
        <img class="unkown-icon" src="../assets/unkown.png" />
        <div class="empty-text">{{ emptyMessage }}</div>
      </div>
      <!-- 内容 -->
      <div class="content" v-else>
        <div class="weather-message">
          <div class="weather-message-container">
            <img class="weather-message-icon" :src="getWeatherData.icon === undefined ? '' : `${getIconUrl}${getWeatherData.icon}.png`">
            <div class="weather-data">{{ $store.getters["weather/getWeatherData"].temp }}</div>
            <div class="weather-data-unit">°C</div>
            <div class="weather-type">{{ $store.getters["weather/getWeatherData"].text }}</div>
          </div>
          <div class="sensor-group">
            <div class="sensor">
              <img class="sensor-icon" src="../assets/humidity.png" />
              <span class="sensor-name">湿度</span>
              <span class="sensor-data">
                {{ $store.getters["weather/getWeatherData"].humidity }}
                <span clsss="sensor-unit">%</span>
              </span>
            </div>
            <div class="sensor">
              <img class="sensor-icon" src="../assets/pressure.png" />
              <span class="sensor-name">气压</span>
              <span class="sensor-data">
                {{ $store.getters["weather/getWeatherData"].pressure }}
                <span class="sensor-unit">mb</span>
              </span>
            </div>
            <div class="sensor">
              <img class="sensor-icon" src="../assets/wind_speed.png" />
              <span class="sensor-name">风速</span>
              <span class="sensor-data">
                {{ $store.getters["weather/getWeatherData"].windSpeed }}
                <span class="sensor-unit">km/h</span>
              </span>
            </div>
            <div class="sensor">
              <img class="sensor-icon" src="../assets/wind_direction.png" />
              <span class="sensor-name">风向</span>
              <span class="sensor-data">{{ $store.getters["weather/getWeatherData"].windDir }}</span>
            </div>
          </div>
        </div>
        <!-- 24小时温度 -->
        <div class="weather-chart-container">
          <div class="weather-chart-title">
            <Icon class="weather-chart-icon" type="ios-stats" size="18" />
            <div>24小时温度</div>
          </div>
          <div id="weather-chart"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const echarts = require("echarts");
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "weather",
  data() {
    return {
      empty: false,
      loading: true,
      weatherChart: null,
      emptyMessage: "暂无数据"
    }
  },
  async mounted() {
    // 开启加载动画
    this.loading = true;
    // 请求天气数据
    await this.getWeather()
      .then(res => {
        // 特殊情况
        if (res.data.error_code === 60001) {
          this.loading = false;
          this.empty = true;
          this.emptyMessage = res.data.msg;
          return;
        }
        // 判断status为200
        if (res.data.status === 200) {
          // 设置城市名称
          this.setCityName({
            cityName: res.data.data.city_name
          });
          // 设置天气数据
          this.setWeatherData({
            weatherData: res.data.data.weather_data.now
          });
          // 设置精确到每小时的气温图数据
          this.setHourlyData({
            hourlyData: res.data.data.hourly_data.hourly
          });
          // 关闭加载动画
          this.loading = false;
          // 加载气温图
          let hourlyData = this.$store.getters["weather/getHourlyData"];
          let time = [];
          let tem = [];
          // 24小时数据，第一个时间显示为'现在'这两个字
          hourlyData.forEach((item) => {
            if (item.time[0] === '0' ) {
              time.push(`${item.time[1]}点`);
            } else {
              time.push(`${item.time}点`);
            }
            tem.push(item.tem);
          });
          this.$nextTick(() => {
            // 设置图表数据
            this.setChart(time, tem);
          });
        }
      })
      .catch(error => {
        this.loading = false;
        this.empty = true;
        console.log(error);
      });
  },
  computed: {
    ...mapGetters("weather", [
      "getIconUrl",
      "getWeatherData"
    ]),
  },
  methods: {
    ...mapActions("weather", [
      "getWeather"
    ]),
    ...mapMutations("weather", [
      "setCityName",
      "setWeatherData",
      "setHourlyData"
    ]),
    setChart(time, data) {
      this.weatherChart = echarts.init(document.getElementById("weather-chart"));
      let options = {
        color: "#016f91",
        grid: {
          top: "8%",
          bottom: "13%",
          left: "6%",
          right: "0%"
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          },
          data: time
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          },
        },
        series: [{
          data: data,
          type: "line",
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1,[
                {
                  offset: 0,
                  color: "#017092"
                },
                {
                  offset: 0.5,
                  color: "#016586"
                },
                {
                  offset: 1,
                  color:"#002d4b"
                }
              ])
            }
          }
        }]
      };
      window.addEventListener("resize", this.resizeChart);
      this.weatherChart.setOption(options);
    },
    resizeChart() {
      this.weatherChart.resize();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeChart);
  }
}
</script>

<style scoped>
.weather {
  position: absolute;
  left: 20px;
  top: calc((100% - 80px) / 3 + 40px);
  width: 26.615vw;
  height: calc((100% - 80px) / 3);
  background-color: rgba(0, 40, 69, 0.8);
  border-radius: 0.5vw;
}

.tab {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-name {
  font-size: 1.172vw;
  color: #FFFFFF;
  padding-left: 1vw;
}

.tab-city {
  display: flex;
  align-items: center;
  padding-right: 1vw;
}

.city-text {
  display: flex;
  align-items: center;
  color: #02bae1;
  font-size: 0.8vw;
}

.city-icon {
  display: block;
  width: 1vw;
  height: 1vw;
  margin-top: 2px;
  margin-right: 0.3vw;
}

.city-name {
  color: #FFFFFF;
  font-size: 1vw;
  padding-left: 0.3vw;
}

.loading {
  width: 100%;
  height: 80%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  padding-left: 0.2vw;
  font-size: 0.6vw;
}

.empty {
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.unkown-icon {
  width: 1vw;
  height: 1vw;
}

.empty-text {
  padding-left: 0.2vw;
  color: #808695;
  font-size: 0.6vw;
}

.content {
  position: relative;
  width: 100%;
  height: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1vw;
  box-sizing: border-box;
}

.weather-message {
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
}

.weather-message-container {
  position: relative;
  width: 40%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.weather-message-icon {
    display: block;
    width: 3.2vw;
    height: 3.2vw;
}

.weather-data {
    font-size: 1.6vw;
}

.weather-data-unit {
    font-size: 0.8vw;
    align-self: flex-end;
    padding-left: 0.2vw;
    padding-bottom: 0.72vw;
}

.weather-type {
    font-size: 0.8vw;
    align-self: flex-end;
    padding-left: 0.2vw;
    padding-bottom: 0.72vw;
}

.sensor-group {
  position: relative;
  width: 60%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.sensor {
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
  height: 50%;
}

.sensor-icon {
  width: 1vw;
  height: 1vw;
}

.sensor-name {
    font-size: 0.6vw;
    color: rgba(167, 167, 167, 1);
    margin-left: 0.15vw;
    margin-right: 0.15vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sensor-data {
    font-size: 0.6vw;
    color: #FFFFFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sensor-unit {
  font-size: 0.6vw;
  color: #FFFFFF;
}

.weather-chart-container {
  position: relative;
  width: 100%;
  height: 80%;
}

.weather-chart-title {
  position: relative;
  width: 100%;
  height: 16%;
  color: #00c6f6;
  font-size: 0.7vw;
  display: flex;
  align-items: center;
}

.weather-chart-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1vw;
  height: 1vw;
  margin-right: 0.2vw;
}

#weather-chart {
  position: relative;
  width: 100%;
  height: 84%;
}
</style>
